import { PriceFeedItem } from '@/components/molecules'
import { Box, Spinner } from '@chakra-ui/react'

export const PriceFeedsList = ({ isLoading, items }) => {
  if (isLoading) {
    return <Spinner />
  }
  return (
    <Box>
      {items?.map((item) => (
        <PriceFeedItem key={item.id} item={item} />
      ))}
    </Box>
  )
}
